// @flow
import serverProps from './serverProps'
import _ from 'lodash'

const CDN_HOST_NAME = _.get(serverProps, 'cdnHostName')

/**
 * A helper to build image urls
 * @param { string } id — represents the theme id. e.g. "1", "1337", etc.
 * @param { string } type — represents the size/use-case. e.g. "card", "email", "activity" (check PayPal objects for exhaustive list)
 * @param { string } format — represents the image format type
 * @return { string }
 */
export function getThemeImage(
  id: string,
  type: string,
  format: string = 'svg'
) {
  return `${CDN_HOST_NAME}/digitalassets/c/consumer/p2p/gift-themes/${id}-${type}.${format}`
}
